import React, { Component } from "react";
import {
  ScrollView,
  View,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
  Platform,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Timeline from "react-native-timeline-flatlist";
import { translate, CurrentLocale } from "../locales/translate";
import Loading from "../components/Loading";
import { ArButton } from "../argon-ui";
import Theme from "../argon-ui/Theme";
let moment = require("moment-jalaali");

const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;
const IS_MOBILE = Platform.OS === "android" || Platform.OS == "ios";
class ScenarioReportScreen extends Component {
  constructor(props) {
    super(props);

    let _scenarioId = 0;
    let _scenarioUId = "";
    let _scenarioName = "";
    if (
      this.props.navigation.state.params &&
      this.props.navigation.state.params.scenarioId
    ) {
      _scenarioId = this.props.navigation.state.params.scenarioId;
      _scenarioUId = this.props.navigation.state.params.scenarioUId;
      _scenarioName = this.props.navigation.state.params.scenarioName;
    }

    this.state = {
      isConsumptionLoading: true,
      isTimelineLoading: true,
      serverUrl: undefined,
      accessToken: undefined,
      buildingId: "",
      scenarioId: _scenarioId,
      scenarioUId: _scenarioUId,
      scenarioName: _scenarioName,
      deviceType: "",
      consumptionData: [],
      consumptionTotalUsage: "",
      totalUsageText: translate("deviceLog.totalUsage"),
      timeLine: [],
      timelineFilters: {
        isLoadingMore: false,
        page: 1,
        withDevice: true,
        withUser: true,
        withScenario: true,
        withArea: true,
        withSchedule: true,
      },
      showDatePicker: false,
      dateFrom: null,
      dateTo: null,
      monthlyStartYear: undefined,
      monthlyStartMonth: 1,
      monthlyEndYear: undefined,
      monthlyEndMonth: 1,
      duration: "today",
      customDuration: "daily",
      locale: CurrentLocale,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.ScenarioReportScreen"),
  });
  componentDidMount() {
    if (this.state.scenarioId) {
      let { currentServer, currentBuilding, serverUrl } = this.props.appReducer;
      this.setState(
        {
          accessToken: currentServer.accessToken,
          serverUrl,
          buildingId: currentBuilding?.buildingId || "",
        },
        () => {
          this.getAllReports();
        }
      );
    }
  }

  getAllReports = () => {
    this.getTimelineLog();
  };

  getTimelineLog = (keepLogs = false) => {
    let {
      serverUrl,
      accessToken,
      timelineFilters,
      buildingId,
      scenarioId,
      scenarioUId,
    } = this.state;
    timelineFilters.isLoadingMore = true;
    this.setState({
      isTimelineLoading: !keepLogs && true,
      timelineFilters,
      showDatePicker: false,
    });
    if (serverUrl) {
      // filters
      var filters = [];

      let { page, withDevice, withScenario, withUser, withSchedule, withArea } =
        this.state.timelineFilters;
      filters.push(`buildingId=${buildingId}`);
      filters.push(`d=${withDevice}`);
      filters.push(`s=${withScenario}`);
      filters.push(`u=${withUser}`);
      filters.push(`a=${withArea}`);
      filters.push(`sc=${withSchedule}`);
      if (scenarioId) {
        filters.push(`id=${scenarioId}`);
      }
      if (scenarioUId) {
        filters.push(`uId=${scenarioUId}`);
      }
      if (page > 1) filters.push(`p=${page}`);

      // end filters
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      var url = `${serverUrl}Log/ScenarioTimeLine?${filters.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          timelineFilters.isLoadingMore = false;

          this.setState({
            isTimelineLoading: false,
            timelineFilters,
          });
          return res.json();
        })
        .then((resj) => {
          if (resj.scenarioId && resj.logs != null) {
            if (resj.p && resj.p > 1) {
              // for pages above 1, push new logs to old ones.
              timelineFilters.isLoadingMore = false;
              this.setState({
                timeLine: [...this.state.timeLine, ...resj.logs],
                isTimelineLoading: false,
                timelineFilters,
              });
            } else {
              // but if page is not specified or page == 1, override timeline with new logs.
              timelineFilters.isLoadingMore = false;

              this.setState({
                timeLine: resj.logs,
                isTimelineLoading: false,
                timelineFilters,
              });
            }
          } else {
            timelineFilters.isLoadingMore = false;

            this.setState({
              serverAuthErrors: resj.errors,
              isTimelineLoading: false,
              timelineFilters,
            });
          }
        })
        .catch((err) => {
          {
            console.log(err);
            timelineFilters.isLoadingMore = false;

            this.setState({ isTimelineLoading: false, timelineFilters });
          }
        });
    }
  };

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  handleOnDatePick = (tick, p) => {
    let f = this.state.dateFrom != null;
    let t = this.state.dateTo != null;
    if (p == "START_DATE") {
      //(f && t) || (!f && !t) both are selected or both are empty
      // set from date and clear toDate
      this.setState({ dateFrom: tick, dateTo: null });
    } else {
      this.setState({ dateTo: tick });
    }
  };

  renderTimeline = () => {
    if (this.state.isTimelineLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View style={styles.section}>
        <View style={styles.timeLineWrapper}>
          <Text style={styles.chartTitle}>
            {translate("deviceLog.activities")}
          </Text>
          <View
            style={{
              // flex: 1,
              flexDirection: "row",
              marginBottom: 15,
              marginHorizontal: 10,
              alignItems: "center",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <ScrollView horizontal contentContainerStyle={{ flexGrow: 1 }}>
              {/* with device */}
              <View style={{ flex: 1, flexDirection: "row", paddingEnd: 10 }}>
                <Text style={{ marginHorizontal: 5 }}>
                  {translate("deviceLog.event")}
                </Text>
                <Switch
                  isOn={this.state.timelineFilters.withDevice}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={(v) => {}}
                  animationSpeed={0}
                />
              </View>
              {/* end with device */}
              {/* with user */}
              <View style={{ flex: 1, flexDirection: "row" }}>
                <Text style={{ marginHorizontal: 5 }}>
                  {translate("deviceLog.user")}
                </Text>

                <Switch
                  isOn={this.state.timelineFilters.withUser}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={(v) => {
                    let { timelineFilters } = this.state;
                    timelineFilters.withUser = v;
                    timelineFilters.page = 1;
                    this.setState({ timelineFilters });
                    this.getTimelineLog();
                  }}
                  animationSpeed={0}
                />
              </View>
              {/* end with user */}
              {/* start with arm */}
              <View style={{ flex: 1, flexDirection: "row" }}>
                <Text style={{ marginHorizontal: 5 }}>
                  {translate("deviceLog.schadule")}
                </Text>
                <Switch
                  isOn={this.state.timelineFilters.withSchedule}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={(v) => {
                    let { timelineFilters } = this.state;
                    timelineFilters.withSchedule = v;
                    timelineFilters.page = 1;
                    this.setState({ timelineFilters });
                    this.getTimelineLog();
                  }}
                  animationSpeed={0}
                />
              </View>
            </ScrollView>
          </View>
          {this.state.timeLine && this.state.timeLine.length > 0 && (
            <View style={{ direction: "ltr" }}>
              <Timeline
                data={this.state.timeLine}
                columnFormat={
                  IS_MOBILE ? "single-column-left" : "single-column-right"
                }
                timeStyle={{
                  minWidth: 120,
                }}
                eventContainerStyle={{}}
                renderDetail={(rowData) => {
                  return (
                    <View
                      style={{
                        backgroundColor:
                          rowData.cause == "scenario" ||
                          rowData.cause == "areaarm" ||
                          rowData.cause == "areastate"
                            ? "#66999910"
                            : rowData.status < 0
                            ? "#d4e4ff"
                            : rowData.status
                            ? "#ffa726"
                            : Theme.COLORS.MUTED,
                        borderRadius: 15,
                        borderColor:
                          rowData.cause == "scenario" ||
                          rowData.cause == "areaarm" ||
                          rowData.cause == "areastate"
                            ? "#669999"
                            : "transparent",
                        borderWidth:
                          rowData.cause == "scenario" ||
                          rowData.cause == "areaarm" ||
                          rowData.cause == "areastate"
                            ? 1
                            : 0,
                        padding: 15,
                        flex: 1,
                      }}
                    >
                      {rowData.title != null && (
                        <Text style={{ fontWeight: "bold" }}>
                          {translate(`scenarioLog.${rowData.cause}`)}:{" "}
                          {rowData.cause == "device"
                            ? translate(`deviceLog.${rowData.Description}`)
                            : rowData.Description}
                        </Text>
                      )}
                      {rowData.title == null && (
                        <Text style={{ fontWeight: "bold" }}>
                          {translate(`scenarioLog.${rowData.cause}`)}
                        </Text>
                      )}

                      <View style={{}}>
                        {rowData.description != null && (
                          <Text style={{}}>
                            {rowData.description == "ChangeCommandSent"
                              ? rowData.status == undefined ||
                                rowData.status < 0
                                ? translate(
                                    `deviceLog.ChangeCommandSentNoStatus`
                                  )
                                : translate(
                                    `deviceLog.${rowData.description}`,
                                    {
                                      status: rowData.status,
                                    }
                                  )
                              : translate(`deviceLog.${rowData.description}`)}
                          </Text>
                        )}
                      </View>
                    </View>
                  );
                }}
              />
            </View>
          )}
          {this.renderTimelineLoadMore()}
        </View>
      </View>
    );
  };

  renderTimelineLoadMore = () => {
    if (this.state.timelineFilters.isLoadingMore) {
      return <Loading message="" />;
    } else if (this.state.timeLine.length > 0) {
      return (
        <ArButton
          style={{ marginBottom: 20, alignSelf: "center" }}
          color="primary"
          onPress={() => {
            let { timelineFilters } = this.state;
            timelineFilters.page++;
            timelineFilters.isLoadingMore = true;
            this.setState({ timelineFilters }, () => {
              this.getTimelineLog(true);
            });
          }}
        >
          <Text style={{ color: "#FFF" }}>
            {translate("deviceLog.olderLogs")}
          </Text>
        </ArButton>
      );
    }
    return null;
  };

  render() {
    return (
      <ScrollView>
        <View style={{ alignItems: "center" }}>
          <Text
            style={{ fontSize: 18, fontWeight: "bold", paddingVertical: 10 }}
          >
            {this.state.scenarioName}
          </Text>
          {this.renderTimeline()}
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  section: {
    borderTopColor: Theme.COLORS.BORDER,
    borderTopWidth: 1,
    paddingTop: 15,
    width: "100%",
  },
  chartWrapper: {
    marginVertical: 15,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.BLOCK,
  },
  chartTitle: {
    fontSize: 18,
    padding: 10,
  },
  totalUsageText: {
    fontWeight: "bold",
    fontSize: 36,
    textAlign: "left",
    writingDirection: "ltr",
    color: Theme.COLORS.MUTED,
    // borderWidth: 1,
    // borderColor: "green",
    //flex: 1,
  },
  timeLineWrapper: {
    marginTop: 15,
    width: "100%",
    paddingHorizontal: 10,
    borderTopColor: Theme.COLORS.BORDER,
    borderTopWidth: 1,
    paddingTop: 15,
  },
  timeLineEventContainer: {
    backgroundColor: "#fea320",
    borderRadius: 15,
    marginBottom: 15,
  },
  totalUsage: {
    fontWeight: "bold",
    fontSize: 36,
    textAlign: "left",
    writingDirection: "ltr",
    // borderWidth: 1,
    // borderColor: "green",
    //flex: 1,
  },
  rowCenter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  refreshButton: {
    marginHorizontal: 10,
    backgroundColor: Theme.COLORS.WARNING,
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenarioReportScreen);
